/**
 * Classe che rappresenta i dati precedentemente
 * compilati dall'utente nella pagina di login
 * Viene usata per fare il SingleSignOn (SSO) alle
 * aperture successive
 */
export class SSOLoginData {
    /**
     * Username dell'utente che corrisponde al
     * "putSigla" di Integra
     * Nel caso di logout viene riproposta alla riapertura
     */
    username = '';
    /**
     * Password dell'utente
     * Nel caso di logout NON viene riproposta se no rientrerebbe
     * automaticamente venendo sovrascritta in vuoto
     */
    password = '';
    /**
     * Alias associato al cliente
     * Nel caso di logout viene riproposta alla riapertura
     */
    alias = '';
    /**
     * Indirizzo del server associato al cliente
     * Nel caso di logout viene riproposta alla riapertura
     */
    serverName = '';   
}